<template>
  <div class="segmented-control" role="group">
    <SegmentedButton
      v-for="option in options"
      :key="option.value"
      :label="option.label"
      :selected="option.value === modelValue"
      @click="select(option.value)"
    />
  </div>
</template>

<script setup>
import SegmentedButton from "./SegmentedButton.vue";

const props = defineProps({
  options: {
    type: Array,
    required: true,
  },
  modelValue: {
    type: [String, Number],
    default: null,
  },
});

const emit = defineEmits(["update:modelValue", "change"]);

function select(value) {
  if (value === props.modelValue) return;

  emit("update:modelValue", value);
  emit("change", value);
}
</script>

<style lang="scss" scoped>
@import "@/assets/scss/variables.scss";

.segmented-control {
  display: inline-flex;
  background-color: white;
  border: 1px solid $grayFour;
  border-radius: 8px;
  overflow: hidden;
}

:deep(.segmented-button) {
  padding: 10px 16px;
  border: none;
  background-color: transparent;
  color: $bluFour;
  font-family: OpenSansSemiBold;
  font-size: $fontMiddle;
  cursor: pointer;
  transition: all 0.2s;
  white-space: nowrap;
}

:deep(.segmented-button:not(:last-child)) {
  border-right: 1px solid $grayFour;
}

:deep(.segmented-button.is-selected) {
  background-color: $bluFour;
  color: white;
}

:deep(.segmented-button:hover:not(.is-selected)) {
  opacity: 0.8;
}
</style>
